import { useEffect, useLayoutEffect, useRef, useState } from "react"
import { StoreClass } from "../stores/Store"
import { publicUrl } from "../utils/url";
import { observer } from "mobx-react-lite";
import { __, __t } from "../utils/translation";
import { useWindowSize } from "../hooks/useWindowSize";
import { Checked } from "../icons/Checked";

/**
 * 
 * @param {{store:StoreClass, items:Array, selected:Number, onTabChange:Function}} param0 
 * @returns 
 */
const AppTabsC = ({ store, items, selected, onTabChange, className = '', onPrev = null, onNext = null, children }) => {
    const cursor = useRef();
    const currentTab = useRef();
    const { width } = useWindowSize();
    const [styles, setStyles] = useState({
        left: 0,
        width: 0
    });
    const [tabsStyles, setTabsStyles] = useState({
        scrollLeft: 0,
    });


    const update = () => {
        const el = document.querySelector(`[data-catid="${selected}"]`);
        if (el) {
            const tabs = el.parentNode;
            const offset = 40;
            var scroll = Math.max(0, Math.min(tabs.scrollWidth - tabs.clientWidth, el.offsetLeft - tabs.clientWidth / 2 - offset));
            const rect = el.getBoundingClientRect();
            tabs.scrollTo({
                top: 0,
                left: scroll,
                behavior: "smooth",
            });
            console.log({
                l: scroll,
                el: tabs,
                left: el.offsetLeft / 2,
            })
            setStyles({
                // left: rect.left,
                left: el.offsetLeft - scroll,
                width: rect.width
            })
        }
        if (currentTab && currentTab.current) {
            // currentTab.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
        }
        console.log({ el, currentTab });
    }

    useEffect(() => {
        update();
        // setTimeout(() => {
        //     update();
        // }, 300);
        return () => {

        }
    }, [selected, cursor, width, currentTab]);



    // if (items.length === 0) {
    //     return null;
    // }



    return <>
        <div className={`AppTabs ${className}`}>

            {items.length > 0 &&
                <div className="AppTabs__boundary">
                    {onPrev &&
                        <div onClick={onPrev} className="AppTabs__prev"></div>}
                    {onNext &&
                        <div onClick={onNext} className="AppTabs__next"></div>}
                    <div style={tabsStyles} className={`AppTabs__tabs`}>

                        {
                            items.map(c => {
                                const removable = Boolean(c.remove);
                                const checked = removable && store.selectedMaterials.some(m => m.category_id === c.id);
                                var label = String(__t(c.name)).replace(/ /, " ");
                                if (c.icon) {
                                    label = <img src={publicUrl(`/icons/${c.icon}`)} alt={label} />
                                }
                                return <button ref={selected === c.id ? currentTab : null} data-catid={c.id} key={c.id}
                                    onClick={e => {
                                        onTabChange(c.id)
                                    }}
                                    className={`AppTab ${selected === c.id ? ' active' : ''}`}>
                                    {label}
                                    {checked && <Checked />}

                                </button>

                            })
                        }


                    </div>
                </div>
            }

            <svg style={{ position: 'absolute' }} height="0" width="0">
                <defs>
                    <clipPath id="leftCorner">
                        <path d="M0 13.967V14h14V0h-.033C13.474 7.488 7.487 13.474 0 13.967Z"></path>
                    </clipPath>
                    <clipPath id="rightCorner">
                        <path d="M0.0 -6.10526e-07L0 -6.11959e-07L-6.11959e-07 14L14 14L14 13.9672C6.51249 13.4744 0.525635 7.48751 0.0328045 -6.10526e-07Z"></path>
                    </clipPath>
                </defs>
            </svg>

            <div className={`${items.length > 0 ? `tabs-wrapper` : ''}`}>
                {items.length > 0 &&
                    <div ref={cursor} style={styles} className="AppTabs__cursor"></div>
                }

                {children}

            </div>
        </div >
    </>
}
const AppTabs = observer(AppTabsC)
AppTabs.displayName = 'AppTabs';
export {
    AppTabs
}
